/* Active Jobs search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import Auth from '../auth/auth';

export interface ISearchFiltersActiveJobsState {
    coordinator: string;
    manager: string;
    regionId: any;
    statusId: any;
}

const auth = new Auth();
let initialState: ISearchFiltersActiveJobsState = {
    coordinator: auth.isEmployee() ? auth.getSessionUsername() : '',
    manager:  auth.isAdmin() ? auth.getSessionUsername() : '',
    regionId: -1,
    statusId: -1,
};
if (initialState.manager !== '') {
    initialState.coordinator = '';
}

export function searchFiltersActiveJobsReducer(state: ISearchFiltersActiveJobsState = initialState, action: any): ISearchFiltersActiveJobsState {
    switch (action.type) {
        case Actions.ACTIVE_JOBS_FILTER_MANAGER:
            return _.merge({}, state, { manager: action.username });
        case Actions.ACTIVE_JOBS_FILTER_COORDINATOR:
            return _.merge({}, state, { coordinator: action.username });
        case Actions.ACTIVE_JOBS_FILTER_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        case Actions.ACTIVE_JOBS_FILTER_REGION:
            return _.merge({}, state, { regionId: action.regionId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersActiveJobsReducer.tsx